import $ from 'jquery';
import {pubsub} from '../../../Core/PubSub';

$.initialize('[data-role="DblLabelCheckbox"]', function () {
  $(this).dblLabelCheckbox();
});
$.widget('lp.dblLabelCheckbox', {
  options: {
    classes: {on: '', off: 'grey text'},
  },

  $wrapper: null,
  $labels: null,

  _create: function () {
    var that = this,
      $checkbox = this.element;

    $checkbox.wrap($('<div>').addClass('dbl-label-checkbox'));
    this.$wrapper = $checkbox.parent();

    var $labels = $checkbox.find('label');

    this.$labels = {
      left: $labels.filter('[data-position="before"]'),
      right: $labels.filter('[data-position="after"]'),
    };

    // set initial state
    that._setLabelClasses();

    this.$labels.left.detach().prependTo(this.$wrapper);
    this.$labels.right.detach().appendTo(this.$wrapper);
  },

  _init: function () {
    var that = this,
      $checkbox = this.element;

    // register change-listener
    $checkbox.checkbox({
      onChange: function () {
        that._setLabelClasses();
        that._publishChangeEvent();
      },
    });

    this.$labels.left.on('click', function () {
      if ($checkbox.checkbox('is checked')) {
        $checkbox.checkbox('set unchecked');
        that._setLabelClasses();
        that._publishChangeEvent();
      }
    });

    this.$labels.right.on('click', function () {
      if ($checkbox.checkbox('is unchecked')) {
        $checkbox.checkbox('set checked');
        that._setLabelClasses();
        that._publishChangeEvent();
      }
    });
  },

  _publishChangeEvent: function () {
    var $checkbox = this.element;
    pubsub.publish('DblLabelChanged-' + $checkbox.find('input').attr('name'), {checkbox: $checkbox});
  },

  _setLabelClasses: function () {
    var $checkbox = this.element,
      cls = this.options.classes;

    if ($checkbox.checkbox('is checked')) {
      this.$labels.left.removeClass(cls.on).addClass(cls.off);
      this.$labels.right.removeClass(cls.off).addClass(cls.on);
    } else {
      this.$labels.left.removeClass(cls.off).addClass(cls.on);
      this.$labels.right.removeClass(cls.on).addClass(cls.off);
    }
  },
});
